import { createDraftSafeSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GlobalState } from '@store'
import { LoadingState, User } from '@types'

interface signupState {
  loadingStatus: LoadingState
  message: string
  createdUser?: User
}

const initialState: signupState = {
  loadingStatus: 'NOT_STARTED',
  message: '',
  createdUser: undefined
}

export type signupAction = PayloadAction<User>

const signupSlice = createSlice({
  name: 'signup',
  initialState,

  reducers: {
    signup: (state, _action: signupAction) => {
      return {
        ...state,
        loadingStatus: 'LOADING'
      }
    },
    signupSuccess: (state, action: PayloadAction<User>) => {
      return {
        ...state,
        loadingStatus: 'SUCCESS',
        createdUser: action.payload
      }
    },
    signupFailed: (state, action) => {
      return {
        ...state,
        loadingStatus: 'FAILED',
        message: action.payload
      }
    },
    clearSignup: _state => {
      return initialState
    }
  }
})

export const signupLoader = createDraftSafeSelector(
  [
    (state: GlobalState) => state.signup.loadingStatus,
    (state: GlobalState) => state.signup.message,
    (state: GlobalState) => state.signup.createdUser
  ],
  (loadingStatus, message, createdUser) => {
    const isLoading = loadingStatus === 'LOADING'
    const isFailed = loadingStatus === 'FAILED'
    const isSuccess = loadingStatus === 'SUCCESS'
    return { isLoading, isFailed, isSuccess, message, createdUser }
  }
)

export const { signup, signupSuccess, signupFailed, clearSignup } = signupSlice.actions
export default signupSlice.reducer
